// FETCH ALL PROPERTIES FROM STYLE_MASTER PAGE
export const FETCH_STYLE_MASTER_MAIN_REQUEST = 'FETCH_STYLE_MASTER_MAIN_REQUEST';
export const FETCH_STYLE_MASTER_MAIN_SUCCESS = 'FETCH_STYLE_MASTER_MAIN_SUCCESS';
export const FETCH_STYLE_MASTER_MAIN_FAILURE = 'FETCH_STYLE_MASTER_MAIN_FAILURE';

// FETCH ALL PROPERTIES FROM STYLE_MASTER PAGE
export const FETCH_STYLE_MASTER_MAIN_BUYER_NAME_REQUEST = 'FETCH_STYLE_MASTER_MAIN_BUYER_NAME_REQUEST';
export const FETCH_STYLE_MASTER_MAIN_BUYER_NAME_SUCCESS = 'FETCH_STYLE_MASTER_MAIN_BUYER_NAME_SUCCESS';
export const FETCH_STYLE_MASTER_MAIN_BUYER_NAME_FAILURE = 'FETCH_STYLE_MASTER_MAIN_BUYER_NAME_FAILURE';


export const FETCH_STYLE_MASTER_MAIN_STYLE_NUMBER_REQUEST = 'FETCH_STYLE_MASTER_MAIN_STYLE_NUMBER_REQUEST';
export const FETCH_STYLE_MASTER_MAIN_STYLE_NUMBER_SUCCESS = 'FETCH_STYLE_MASTER_MAIN_STYLE_NUMBER_SUCCESS';
export const FETCH_STYLE_MASTER_MAIN_STYLE_NUMBER_FAILURE = 'FETCH_STYLE_MASTER_MAIN_STYLE_NUMBER_FAILURE';


// CREATE PROPERTIES FOR STYLE_MASTER PAGE
export const CREATE_STYLE_MASTER_MAIN_REQUEST = 'CREATE_STYLE_MASTER_MAIN_REQUEST';
export const CREATE_STYLE_MASTER_MAIN_SUCCESS = 'CREATE_STYLE_MASTER_MAIN_SUCCESS';
export const CREATE_STYLE_MASTER_MAIN_FAILURE = 'CREATE_STYLE_MASTER_MAIN_FAILURE';

// UPDATE PROPERTIES FOR STYLE_MASTER PAGE
export const UPDATE_STYLE_MASTER_MAIN_REQUEST = 'UPDATE_STYLE_MASTER_MAIN_REQUEST';
export const UPDATE_STYLE_MASTER_MAIN_SUCCESS = 'UPDATE_STYLE_MASTER_MAIN_SUCCESS';
export const UPDATE_STYLE_MASTER_MAIN_FAILURE = 'UPDATE_STYLE_MASTER_MAIN_FAILURE';

// FETCH SINGLE PROPERTY FOR STYLE_MASTER PAGE
export const FETCH_SINGLE_STYLE_MASTER_MAIN_REQUEST = 'FETCH_SINGLE_STYLE_MASTER_MAIN_REQUEST';
export const FETCH_SINGLE_STYLE_MASTER_MAIN_SUCCESS = 'FETCH_SINGLE_STYLE_MASTER_MAIN_SUCCESS';
export const FETCH_SINGLE_STYLE_MASTER_MAIN_FAILURE = 'FETCH_SINGLE_STYLE_MASTER_MAIN_FAILURE';

export const CHECK_DEMAND_BY_STYLE_ID_REQUEST = 'CHECK_DEMAND_BY_STYLE_ID_REQUEST';
export const CHECK_DEMAND_BY_STYLE_ID_SUCCESS = 'CHECK_DEMAND_BY_STYLE_ID_SUCCESS';
export const CHECK_DEMAND_BY_STYLE_ID_FAILURE = 'CHECK_DEMAND_BY_STYLE_ID_FAILURE';

// DELETE PROPERTIES FOR STYLE_MASTER PAGE
export const DELETE_STYLE_MASTER_MAIN_REQUEST = 'DELETE_STYLE_MASTER_MAIN_REQUEST';
export const DELETE_STYLE_MASTER_MAIN_SUCCESS = 'DELETE_STYLE_MASTER_MAIN_SUCCESS';
export const DELETE_STYLE_MASTER_MAIN_FAILURE = 'DELETE_STYLE_MASTER_MAIN_FAILURE';

export const CREATE_USER_FORM_STYLE_MASTER_MAIN = 'CREATE_USER_FORM_STYLE_MASTER_MAIN';
export const STYLE_MASTER_MAIN_USERFORM_RESET = 'STYLE_MASTER_MAIN_USERFORM_RESET';
export const STYLE_MASTER_MAIN_USERFORM_DROPDOWNLIST_RESET = 'STYLE_MASTER_MAIN_USERFORM_DROPDOWNLIST_RESET';

// navigate to access info page
export const NAVIGATE_STYLE_MASTER = 'NAVIGATE_STYLE_MASTER';
export const NAVIGATE_STYLE_MASTER_MAIN = 'NAVIGATE_STYLE_MASTER_MAIN';
// navigate to access details page
export const NAVIGATE_STYLE_DETAILS = 'NAVIGATE_STYLE_DETAILS';

export const NAVIGATE_STYLE_PREPARATION = 'NAVIGATE_STYLE_PREPARATION';

export const SET_SINGLE_STYLE_MAIN_OBJ = 'SET_SINGLE_STYLE_MAIN_OBJ';


export const CHECK_DEMAND_BY_SALEORDER_ID_REQUEST = 'CHECK_DEMAND_BY_SALEORDER_ID_REQUEST';
export const CHECK_DEMAND_BY_SALEORDER_ID_SUCCESS = 'CHECK_DEMAND_BY_SALEORDER_ID_SUCCESS';
export const CHECK_DEMAND_BY_SALEORDER_ID_FAILURE = 'CHECK_DEMAND_BY_SALEORDER_ID_FAILURE';


export const GET_UPDATE_DATA_REQUEST = 'GET_UPDATE_DATA_REQUEST';
export const GET_UPDATE_DATA_SUCCESS = 'GET_UPDATE_DATA_SUCCESS';
export const GET_UPDATE_DATA_FAILURE = 'GET_UPDATE_DATA_FAILURE';

export const GET_DELETE_DATA_REQUEST = 'GET_DELETE_DATA_REQUEST';
export const GET_DELETE_DATA_SUCCESS = 'GET_DELETE_DATA_SUCCESS';
export const GET_DELETE_DATA_FAILURE = 'GET_DELETE_DATA_FAILURE';

export const STYLE_CREATION_BY_ID_REQUEST = 'STYLE_CREATION_BY_ID_REQUEST';
export const STYLE_CREATION_BY_ID_SUCCESS = 'STYLE_CREATION_BY_ID_SUCCESS';
export const STYLE_CREATION_BY_ID_FAILURE = 'STYLE_CREATION_BY_ID_FAILURE';

export const SET_TAB_FOR_STYLE_CREATION = 'SET_TAB_FOR_STYLE_CREATION';

export const FETCH_STYLE_MASTER_COPY_STYLE_TRACK_CHANGES_REQUEST = 'FETCH_STYLE_MASTER_COPY_STYLE_TRACK_CHANGES_REQUEST';
export const FETCH_STYLE_MASTER_COPY_STYLE_TRACK_CHANGES_SUCCESS = 'FETCH_STYLE_MASTER_COPY_STYLE_TRACK_CHANGES_SUCCESS';
export const FETCH_STYLE_MASTER_COPY_STYLE_TRACK_CHANGES_FAILURE = 'FETCH_STYLE_MASTER_COPY_STYLE_TRACK_CHANGES_FAILURE';
